import { render, staticRenderFns } from "./MyCafeMenu.vue?vue&type=template&id=6ecf504a&"
import script from "./MyCafeMenu.vue?vue&type=script&lang=js&"
export * from "./MyCafeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ecf504a', component.options)
    } else {
      api.reload('6ecf504a', component.options)
    }
    module.hot.accept("./MyCafeMenu.vue?vue&type=template&id=6ecf504a&", function () {
      api.rerender('6ecf504a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/MyCafeMenu.vue"
export default component.exports